import React, {Component} from "react";
import ReactDOM from "react-dom";
import App from "../../index.js";
import "../../../jeep.css"
import { config } from "../../../configs/jeep"
import loaderSvg from "../../../images/jeep-loading.svg";

const brand =  {
    value: "jeep",
    id: 1,
    division : "1",
    name : "Jeep"
};

function JeepApp(props){
    return (
        <App brand={brand} formName={"fca-jeep-ravd"} config={config} loader={loaderSvg} models={config.models}/>
    )
}

ReactDOM.render(<JeepApp/>,document.getElementById("root"));
